import React from 'react';
import '../styles/footer.css';

const Footer: React.FC = () => {
  return (
    <div className="footer-container">
      <p> Copyright © {new Date().getFullYear()} AnasTafish</p>
      <a href="https://github.com/anastafish" target="_blank" rel="noreferrer">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" alt="github" />
      </a>
      <a href="https://www.linkedin.com/in/anas-tafish-665027180/" target="_blank" rel="noreferrer">
        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-plain.svg" alt="LinkedIn" />
      </a>
    </div>
  );
};

export default Footer;
